{
  "48264": [
    48600
  ],
  "48600": [
    48264
  ],
  "46560": [
    31085
  ],
  "31085": [
    23118,
    23525,
    23700,
    24000,
    28740,
    31930,
    34360,
    34400,
    34480,
    37040,
    38270,
    46560
  ],
  "13970": [
    14470
  ],
  "14470": [
    13970,
    14660,
    14955
  ],
  "54520": [
    50970
  ],
  "50970": [
    49930,
    50055,
    51130,
    51280,
    51584,
    51860,
    52510,
    54520,
    57410,
    57840,
    58320
  ],
  "54030": [
    55230
  ],
  "55230": [
    54030,
    55840
  ],
  "53655": [
    53490,
    55080,
    57100
  ],
  "53490": [
    53655,
    55080
  ],
  "11690": [
    10580
  ],
  "10580": [
    11690,
    11770,
    12275,
    12410
  ],
  "31270": [
    23700,
    24000,
    24180,
    29490,
    30230,
    31930,
    34480,
    37040
  ],
  "30230": [
    28654,
    28740,
    31270
  ],
  "37040": [
    31085,
    31270,
    31320,
    31470,
    31550,
    34360
  ],
  "34480": [
    31085,
    31270,
    31320,
    31930,
    33400
  ],
  "24180": [
    31270,
    31550
  ],
  "31320": [
    24040,
    34480,
    37040
  ],
  "24040": [
    31320
  ],
  "12890": [
    12775
  ],
  "12775": [
    12890
  ],
  "12491": [
    11901,
    12410
  ],
  "11901": [
    12491,
    15770,
    30725,
    38395,
    38460
  ],
  "9985": [
    11370
  ],
  "11370": [
    6500,
    9985
  ],
  "9990": [
    8750
  ],
  "8750": [
    9990
  ],
  "14660": [
    14470
  ],
  "14955": [
    14470,
    14500,
    15250,
    15423
  ],
  "14500": [
    14955,
    15170
  ],
  "15170": [
    14500
  ],
  "57818": [
    49930,
    51130,
    57870
  ],
  "57870": [
    57818,
    59960,
    59991
  ],
  "49930": [
    50210,
    50970,
    51584,
    57818,
    57820,
    57840
  ],
  "59960": [
    57870,
    60165,
    60240,
    60390
  ],
  "60165": [
    59960
  ],
  "60390": [
    17700,
    59960,
    59970,
    60140,
    60250,
    61378
  ],
  "57820": [
    49930
  ],
  "59970": [
    57890,
    60240,
    60390
  ],
  "60240": [
    59960,
    59970
  ],
  "57890": [
    59970
  ],
  "57840": [
    49930,
    50970,
    51130,
    57650
  ],
  "51130": [
    50970,
    51811,
    52320,
    57818,
    57840
  ],
  "59991": [
    57870
  ],
  "15370": [
    15423,
    15770
  ],
  "15423": [
    11934,
    14800,
    14955,
    15370,
    15770
  ],
  "38395": [
    11901
  ],
  "38460": [
    11901
  ],
  "15770": [
    9810,
    10772,
    11901,
    11930,
    11934,
    15370,
    15423,
    15990
  ],
  "11934": [
    9810,
    15423,
    15770
  ],
  "9810": [
    11934,
    15770
  ],
  "45880": [
    45730
  ],
  "45730": [
    37770,
    44740,
    44801,
    45821,
    45880
  ],
  "30720": [
    23700,
    25610,
    28654,
    28740
  ],
  "28654": [
    25610,
    28230,
    30230,
    30720
  ],
  "23700": [
    23040,
    30720,
    31085,
    31150,
    31270,
    31550
  ],
  "28740": [
    27650,
    28190,
    28230,
    30230,
    30720,
    30800,
    31085
  ],
  "30725": [
    11901
  ],
  "30800": [
    23107,
    24900,
    28740
  ],
  "24900": [
    27130,
    30800
  ],
  "29490": [
    31270
  ],
  "11048": [
    7650,
    8050,
    10930
  ],
  "10930": [
    11048
  ],
  "8050": [
    11048
  ],
  "45570": [
    39140,
    39720,
    40330,
    44860,
    45793
  ],
  "39140": [
    45570
  ],
  "39720": [
    45515,
    45550,
    45570
  ],
  "45793": [
    31470,
    37770,
    37980,
    38440,
    45570
  ],
  "40330": [
    40690,
    43260,
    44740,
    45570
  ],
  "45650": [
    45515
  ],
  "45515": [
    39720,
    45650
  ],
  "28190": [
    27650,
    28740
  ],
  "45140": [
    39500,
    44801,
    44805,
    45755
  ],
  "45755": [
    37770,
    38440,
    40040,
    44640,
    45140,
    45855,
    45862
  ],
  "44805": [
    43500,
    43560,
    44620,
    44640,
    44650,
    44801,
    45140
  ],
  "44801": [
    43260,
    44740,
    44805,
    45140,
    45730
  ],
  "38440": [
    37990,
    38220,
    38270,
    39550,
    45755,
    45793
  ],
  "38270": [
    31085,
    37770,
    38440,
    38543
  ],
  "38220": [
    37770,
    38440
  ],
  "37770": [
    37990,
    38005,
    38220,
    38270,
    45730,
    45755,
    45793
  ],
  "37990": [
    37290,
    37400,
    37770,
    38440
  ],
  "45821": [
    35700,
    45730,
    45812,
    45855
  ],
  "38543": [
    38270,
    39550,
    44620
  ],
  "39550": [
    38440,
    38543,
    40040
  ],
  "44620": [
    38543,
    44805
  ],
  "37400": [
    31470,
    37900,
    37990
  ],
  "37900": [
    37400
  ],
  "31470": [
    37040,
    37400,
    45793
  ],
  "38170": [
    35650,
    46770
  ],
  "35650": [
    31930,
    38170
  ],
  "38150": [
    45802
  ],
  "45802": [
    38150
  ],
  "37470": [
    35700
  ],
  "35700": [
    37470,
    45821
  ],
  "38005": [
    6500,
    37290,
    37770,
    44740
  ],
  "27650": [
    28190,
    28740
  ],
  "21315": [
    20690
  ],
  "20690": [
    21315
  ],
  "55530": [
    55275
  ],
  "55275": [
    55080,
    55370,
    55530
  ],
  "55560": [
    55617,
    57230
  ],
  "55617": [
    55560
  ],
  "57230": [
    55560
  ],
  "32690": [
    31680
  ],
  "31680": [
    23870,
    24030,
    28828,
    32690
  ],
  "31550": [
    23700,
    24180,
    31930,
    37040
  ],
  "38780": [
    40040,
    45490
  ],
  "45490": [
    38780
  ],
  "31930": [
    31085,
    31270,
    31550,
    34480,
    35650
  ],
  "24030": [
    31680
  ],
  "23870": [
    23040,
    23118,
    31680
  ],
  "28828": [
    31680
  ],
  "605": [
    29110
  ],
  "29110": [
    605
  ],
  "45855": [
    45755,
    45821,
    46090
  ],
  "46090": [
    45855
  ],
  "43260": [
    40080,
    40330,
    44801
  ],
  "56550": [
    61355
  ],
  "61355": [
    56550
  ],
  "40985": [
    40080,
    40460
  ],
  "40080": [
    40985,
    43260
  ],
  "40460": [
    40710,
    40745,
    40790,
    40985
  ],
  "51280": [
    50970
  ],
  "52065": [
    50730
  ],
  "50730": [
    51811,
    52065
  ],
  "50210": [
    49930,
    49962,
    51501,
    51584
  ],
  "51501": [
    50210
  ],
  "51811": [
    50730,
    51130,
    53282
  ],
  "51584": [
    49930,
    50055,
    50210,
    50380,
    50970,
    57410
  ],
  "53282": [
    51811
  ],
  "49962": [
    50210
  ],
  "51860": [
    50970
  ],
  "52510": [
    50970
  ],
  "50055": [
    50970,
    51584
  ],
  "58320": [
    50970
  ],
  "52240": [
    51350
  ],
  "51350": [
    52240
  ],
  "50925": [
    50070
  ],
  "50070": [
    50925
  ],
  "52320": [
    51020,
    51130
  ],
  "51020": [
    52320
  ],
  "33400": [
    34480
  ],
  "34360": [
    31085,
    37040
  ],
  "34400": [
    31085
  ],
  "45080": [
    39370,
    40745,
    40790
  ],
  "40745": [
    40460,
    45080,
    45100
  ],
  "40790": [
    40460,
    45080
  ],
  "39930": [
    40520
  ],
  "40520": [
    39930
  ],
  "45100": [
    40745
  ],
  "40710": [
    40460
  ],
  "40040": [
    38780,
    39550,
    44910,
    45320,
    45755
  ],
  "44910": [
    40040
  ],
  "45320": [
    40040
  ],
  "45550": [
    39720
  ],
  "39500": [
    45140
  ],
  "39370": [
    45080
  ],
  "10772": [
    7650,
    15770
  ],
  "62380": [
    61378,
    61695,
    61932
  ],
  "61932": [
    62380
  ],
  "61378": [
    60390,
    61695,
    62190,
    62380
  ],
  "61695": [
    61378,
    62380
  ],
  "62190": [
    61378
  ],
  "60250": [
    60390
  ],
  "60140": [
    60390
  ],
  "17700": [
    20110,
    60390
  ],
  "12410": [
    10580,
    11770,
    12491
  ],
  "12275": [
    10580
  ],
  "11770": [
    10580,
    12410
  ],
  "45030": [
    44740
  ],
  "44740": [
    38005,
    40330,
    44801,
    45030,
    45730
  ],
  "28230": [
    28654,
    28740
  ],
  "37980": [
    45793
  ],
  "45862": [
    45755
  ],
  "40690": [
    40330
  ],
  "15990": [
    15770
  ],
  "9510": [
    9360
  ],
  "9360": [
    9510
  ],
  "11930": [
    15770
  ],
  "57410": [
    50970,
    51584,
    57462
  ],
  "50380": [
    51584
  ],
  "46910": [
    46870,
    46935
  ],
  "46935": [
    46910
  ],
  "46870": [
    46910
  ],
  "46650": [
    46770
  ],
  "46770": [
    38170,
    46650,
    46690
  ],
  "31150": [
    23700
  ],
  "23118": [
    23870,
    31085
  ],
  "24000": [
    31085,
    31270
  ],
  "23107": [
    30800
  ],
  "23525": [
    31085
  ],
  "23040": [
    23700,
    23870
  ],
  "55330": [
    55080
  ],
  "55080": [
    53490,
    53655,
    55275,
    55330
  ],
  "55840": [
    55230
  ],
  "55130": [
    55350
  ],
  "55350": [
    55130
  ],
  "55370": [
    55275
  ],
  "14800": [
    15423
  ],
  "15250": [
    14955
  ],
  "59580": [
    58370
  ],
  "58370": [
    59580,
    59720
  ],
  "58890": [
    59400
  ],
  "59400": [
    58890
  ],
  "59190": [
    59485
  ],
  "59485": [
    59190
  ],
  "59720": [
    58370
  ],
  "37290": [
    37990,
    38005
  ],
  "6500": [
    11370,
    38005
  ],
  "43560": [
    44200,
    44805
  ],
  "44200": [
    43560,
    44640,
    44650,
    48276
  ],
  "48276": [
    44200
  ],
  "57100": [
    53655,
    57200
  ],
  "57200": [
    57100
  ],
  "24300": [
    26710
  ],
  "26710": [
    24300
  ],
  "25610": [
    28654,
    30720
  ],
  "27130": [
    24900
  ],
  "45812": [
    45821
  ],
  "57462": [
    57410,
    57435
  ],
  "57435": [
    57462
  ],
  "51440": [
    54670
  ],
  "54670": [
    51440
  ],
  "43500": [
    44805
  ],
  "44640": [
    44200,
    44805,
    45755
  ],
  "44860": [
    45570
  ],
  "44650": [
    44200,
    44805
  ],
  "44820": [
    44542
  ],
  "44542": [
    44820
  ],
  "8225": [
    7560,
    7650
  ],
  "7650": [
    8225,
    10772,
    11048
  ],
  "20097": [
    61370
  ],
  "61370": [
    20097
  ],
  "56270": [
    16070
  ],
  "16070": [
    56270
  ],
  "9170": [
    8180
  ],
  "8180": [
    9170
  ],
  "7560": [
    8225
  ],
  "20110": [
    17700
  ],
  "57650": [
    57840
  ],
  "46690": [
    46770
  ]
}